import "react-datepicker/dist/react-datepicker.css";
import { createGlobalStyle } from "styled-components";
import { fontWeightMap as textFontWeightMap } from "../Text/Text.style.js";

export const DatePickerGlobalStyle = createGlobalStyle`
    .react-datepicker {
        border: none;
        padding: ${({ theme }) => theme.spacing[24]};
        border-radius: ${({ theme }) => theme.radius.xs};
        box-shadow: ${({ theme }) => theme.shadows.popover};
        background-color: ${({ theme }) => theme.grayscale.white};
    }

    .react-datepicker__header {
        background-color: ${({ theme }) => theme.grayscale.white};
        border-bottom: none;
    }

    .react-datepicker__day {
        width: ${({ theme }) => theme.spacing[48]};
        color: ${({ theme }) => theme.grayscale[100]};
    }

    .react-datepicker__day--selected,
    .react-datepicker__day--keyboard-selected {
        color: white;
        background-color: ${({ theme }) => theme.colors.primary[100]};
        border-radius: ${({ theme }) => theme.radius.l};
    }

    .react-datepicker__day:hover {
        border-radius: ${({ theme }) => theme.radius.l};
        background-color: ${({ theme }) => theme.grayscale[10]};
    }

    .react-datepicker__day--outside-month {
        color: ${({ theme }) => theme.grayscale[70]};
    }


    .react-datepicker__day--disabled {
        color: ${({ theme }) => theme.grayscale[50]};
    }

    .react-datepicker__day--disabled:hover {
        background-color: transparent;
    }

    .react-datepicker__day-names {
        margin-bottom: 0;
        display: flex;
        justify-content: space-evenly;
    }

    .react-datepicker__day-name {
        width: auto;
    }

    .react-datepicker__month .react-datepicker__month-text {
        color: ${(props) => props.theme.grayscale[100]};
        height: ${(props) => `${props.theme.spacing[40]}`};
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        font-weight: ${textFontWeightMap.semibold};
    }

    .react-datepicker__month-text--keyboard-selected {
        color: ${(props) => props.theme.grayscale[100]};
        background-color: ${(props) => props.theme.grayscale.white};
    }

    .react-datepicker__month--selected, .react-datepicker__month--selected:hover {
        color: white !important;
        background-color: ${(props) => props.theme.colors.primary[100]} !important;
    }

    .react-datepicker__month-text:hover {
        color: ${(props) => props.theme.grayscale[100]};
        background-color: ${(props) => props.theme.grayscale[10]};
    }

    .react-datepicker__month--disabled {
        color: ${(props) => `${props.theme.grayscale[50]} !important`};
    }

    .react-datepicker__week {
        display: flex;
    }

    .react-datepicker__aria-live {
        display: none;
    }
`;
